export default __webpack_public_path__ + "static/media/workouttracker.bfef548b.png";